import React, { useState } from "react"
import styled from "styled-components/macro"
import { useDispatch } from "react-redux"
import { showEditSidebar } from "lib/store/services/editSidebar/slice"

import GET_EXTERNAL_EVENTS_DESTINATION_APIS from "graphql/queries/settings/externalEvents/GetExternalEventsDestinationAPIs"

import PrimaryButton from "components/Ui/Buttons/PrimaryButton"
import DestinationApisTable from "components/ExternalEvents/DestinationApisTable"
import CreateApiDestination from "./CreateApiDestination"

import { ReactComponent as PlusIcon } from "images/icons/plus.svg"
import { useQuery } from "@apollo/client"

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin-top: 2rem;
`

const Container = styled.div`
  position: relative;
  width: 100%;
  min-height: 20rem;
`

const Actions = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
`

const DestinationAPIs = () => {
  const dispatch = useDispatch()
  const { data, loading, error, refetch } = useQuery(GET_EXTERNAL_EVENTS_DESTINATION_APIS)
  const [createDestinationAPI, setCreateDestinationAPI] = useState<boolean>(false)
  const apiDestinations = data?.getExternalEventsDestinationAPIs

  return (
    <>
      <Wrapper>
        {createDestinationAPI && <CreateApiDestination setCreateEventBus={setCreateDestinationAPI} refetch={refetch} />}
        <Container>
          <Actions>
            <h2>API destinations</h2>
            <PrimaryButton
              handleClick={() => {
                dispatch(showEditSidebar())
                setCreateDestinationAPI(true)
              }}
            >
              <PlusIcon />
              Add new API destination
            </PrimaryButton>
          </Actions>
          <DestinationApisTable apiDestinations={apiDestinations} loading={loading} error={error} refetch={refetch} />
        </Container>
      </Wrapper>
    </>
  )
}

export default DestinationAPIs
